module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAYAAAByF90EAAAAAXNSR0IArs4c6QAAAMhJREFUKBWV0TEOgkAQBdCZAW3oPIWtta3Exs7awph4JwviCexsiLbW3sTChIYA6/41EER20E0Izf9vZoFo4GSX3QzPQIxYCwAoS3NFJgh4EcXJ3Zf3Qg1izMSVmR8a1gu1ERvIARmiMSnYF9RFRGgNqKropGEfUB8SLY9nQFm6XWlYA2kIIBwNc9AvyJvyY/xM91MyxY3s37Fqjm9SX6cud9/dzYjDubApNv8gQDEIAzHYda0ho5ASFjqQSDy0SXszl7UddGG8ACdHlu5v21PoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Pods/path.png
// module id = 4TV9
// module chunks = 0